import { Component, Input } from '@angular/core';
import { FlowHistoryItem } from "../../../models/note.model";

@Component({
    selector: 'history-item',
    templateUrl: './history-item.component.html',
    styleUrls: ['./history-item.component.scss', "../notes.component.scss"],
    standalone: false
})
export class HistoryItemComponent {
    @Input()
    item: FlowHistoryItem;

    constructor() { }

    getHistoryItemType(): string {
        if (!this.item)
            return "N/A";
        else
            switch (this.item.type) {
                case 0: return "Flow"
                case 1: return "Work Order";
                default: return "N/A";
            }
    }
}
